export default "__VITE_ASSET___DjHgQKs__"